<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('FinanceManage.AddAssetAccount')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="600px"
  >
    <el-form v-model="form" label-width="120px">
      <el-form-item :label="$t('CargoMsg.Cargo_AccountTitleCode')">
        <el-input v-model="form.accountTitle" :disabled="hasSub" step="1" style="width: 200px" />
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_AccountTitleName')">
        <el-input v-model="form.accountTitleName" style="width: 200px" />
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_ParentAccountTitle')">
        <el-input :value="superAccountTitle?superAccountTitle.accountTitle+'  '+superAccountTitle.accountTitleName:''" disabled :placeholder="$t('CargoMsg.Cargo_NoParentAccountTitles')" style="width: 200px" />
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_AccountTitleCategory')">
        <el-select
          v-model="form.subType"
          :disabled="!(!form.uuid?true:!isUsed)"
          style="width: 200px;"
        >
          <el-option
            v-for="(item, index) in subTypeDDL[accountTitleType-1]"
            :key="index"
            :value="item.code"
            :label="$getLangColumn(item)"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_BalanceDirection')">
        <el-radio v-model="form.debitCrebit" :disabled="isUsed" :label="true">{{ $t('CargoMsg.Cargo_Debit') }}</el-radio>
        <el-radio v-model="form.debitCrebit" :disabled="isUsed" :label="false">{{ $t('CargoMsg.Cargo_Credit') }}</el-radio>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="form.auxiliary" @change="auxiliaryChangeHandler">{{ $t('CargoMsg.Cargo_SubsidiaryAccounting') }}</el-checkbox>
      </el-form-item>
      <el-form-item v-show="form.auxiliary">
        <el-checkbox v-model="form.auxiliaryCustomer">{{ $t('CargoMsg.Cargo_Customer') }}</el-checkbox>
        <el-checkbox v-model="form.auxiliarySupplier">{{ $t('CargoMsg.Cargo_Vendor') }}</el-checkbox>
        <el-checkbox v-model="form.auxiliarySales">{{ $t('CargoMsg.Cargo_Staff') }}</el-checkbox>
        <el-checkbox v-model="form.auxiliaryProjectNumber">{{ $t('CargoMsg.Cargo_Item') }}</el-checkbox>
        <el-checkbox v-model="form.auxiliaryDepartment">{{ $t('CargoMsg.Cargo_Department') }}</el-checkbox>
        <el-form-item v-show="form.auxiliary && form.auxiliaryDepartment">
          <cargo-advance-select
            style="width: 200px"
            filterable
            :select-type="basicCacheKeys.basic_data_Department"
            :default-value="Number(form.defaultDepartment)||''"
            @parentCallBack="item=>form.defaultDepartment=item.value"
          />
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="form.accountingQuantity" @change="accountingQuantityChangeHandler">{{ $t('CargoMsg.Cargo_AccountingQuantity') }}</el-checkbox>
        <span v-show="form.accountingQuantity" style="margin: 0 5px 0 10px">{{ $t('CargoMsg.Cargo_UnitOfMeasurement') }}</span>
        <el-input v-show="form.accountingQuantity" v-model="form.unit" style="width: 200px" />
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="form.accountingCurrency" @change="currencyChangeHandler">{{ $t('CargoMsg.Cargo_ForeignCurrencyAccounting') }}</el-checkbox>
        <el-checkbox v-show="form.accountingCurrency" v-model="form.adjustExchangeRate">{{ $t('CargoMsg.Cargo_PEFEA') }}</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-checkbox-group v-show="form.accountingCurrency" v-model="form.sourceCurrency">
          <el-checkbox v-for="(item, index) in currencys" :key="index" :label="item.code" style="width: 60px">{{ item.code }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="form.currentAccount">{{ $t('CargoMsg.Cargo_CurrentAccount') }}</el-checkbox>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveEventHandler">{{ $t('common.btn.ok') }}</el-button>
      <el-button type="primary" @click="closeHandler">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as AccountTitleType from '@/class/cargo/model/parameters/AccountTitleType'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as accountTitleBalanceApi from '@/api/financeManage/accountTitleBalance'
import * as accountTitleApi from '@/api/financeManage/accountTitle'
import * as fiscalPeriodApi from '@/api/financeManage/fiscalPeriod'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'EntryAccountDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, require: true },
    accountSet: { type: Object, default: null },
    accountTitleType: { type: Number, default: null },
    accountTitle: { type: Object, default: null },
    superAccountTitle: { type: Object, default: null },
    hasSub: { type: Boolean, default: false }
  },
  data() {
    return {
      isUsed: false,
      currencys: [],
      innerVisible: false,
      sourceRow: null,
      saveAccountTitleList: [],
      accountTitleBalance: null,
      basicCacheKeys: basicCacheKeys,
      form: {
        accountTitle: null,
        accountTitleName: '',
        subType: null,
        debitCrebit: true,
        auxiliary: false,
        auxiliaryCustomer: false,
        auxiliarySupplier: false,
        auxiliarySales: false,
        auxiliaryProjectNumber: false,
        auxiliaryDepartment: false,
        accountingQuantity: false,
        unit: '',
        accountingCurrency: false,
        adjustExchangeRate: false,
        currentAccount: false,
        sourceCurrency: [],
        defaultDepartment: null
      },
      subTypeDDL: [
        [AccountTitleType.CURRENTASSETS, AccountTitleType.NONCURRENTASSETS],
        [AccountTitleType.CURRENTLIABILITY, AccountTitleType.NONCURRENTLIABILITY],
        [AccountTitleType.OWNERSEQUITY],
        [AccountTitleType.COST2],
        [AccountTitleType.REVENUE, AccountTitleType.OTHERREVENUE, AccountTitleType.EXPENSE, AccountTitleType.LOSSES, AccountTitleType.COSTANDTAXES, AccountTitleType.ADJUSTINTEREST, AccountTitleType.INCOMETAX]
      ],
      fiscalPeriod: null
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isWT() {
      if (this.accountSet === null) {
        return false
      } else {
        return this.accountSet.softwareVersions === 'WT'
      }
    }
  },
  watch: {
    async visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (newVal) {
        if (this.accountTitle) {
          Object.assign(this.form, this.accountTitle)
          const sourceCurrency = this.accountTitle.sourceCurrency
          if (sourceCurrency) {
            this.form.sourceCurrency = sourceCurrency.split(',')
          } else {
            this.form.sourceCurrency = []
          }
          this.sourceRow = this.accountTitle
        } else {
          this.initForm()
          this.sourceRow = null
          this.saveAccountTitleList = []
          this.accountTitleBalance = null
        }
      } else {
        this.initForm()
        this.sourceRow = null
        this.saveAccountTitleList = []
        this.accountTitleBalance = null
      }
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    this.currencys = await getSpecificBasicData(basicCacheKeys.basic_data_Currency)
  },
  methods: {
    async saveEventHandler() {
      // if (!this.fiscalPeriod) {
      //   await this.getCurrentFiscalPeriod()
      // }
      this.fiscalPeriod = this.accountSet.currentFiscalPeriod
      // 年份
      if (this.fiscalPeriod != null) {
        this.form.year = this.fiscalPeriod.year
        await this.saveHandler()
      } else {
        if (this.isWT) {
          this.$message.info(this.$t('CargoMsg.Cargo_NeedAccountingPeriod'))
          return
        }
        await this.$confirm(this.$t('CargoMsg.Cargo_NFPSCATWBSACYCTS'), this.$t('CargoMsg.Cargo_Tips'))
        this.form.year = new Date().getFullYear()
        await this.saveHandler()
      }
    },
    async saveHandler() {
      const accountTitle = this.form
      // 科目编码
      let code = accountTitle.accountTitle
      // CARGO-488，科目编码能带小数点
      code = code.split('.').join('')
      for (let i = 0; i < this.accountSet.accountTitleGradeRule.length; i++) {
        const rule = Number(this.accountSet.accountTitleGradeRule.charAt(i))
        accountTitle['accountItem' + (i + 1)] = code === '' ? null : code.substring(0, rule)
        if (code !== '') {
          code = code.substring(rule, code.length)
          accountTitle.level = i + 1
        }
      }
      // 账套
      accountTitle.accountSetUuid = this.accountSet.uuid
      // 科目类别
      accountTitle.accountTitleType = this.accountTitleType
      // 勾选外币核算
      if (this.form.accountingCurrency) {
        // 原币种
        let sourceCurrency = ''
        for (const currency of this.form.sourceCurrency) {
          if (currency.length < 3) continue
          if (sourceCurrency) {
            sourceCurrency += ','
          }
          sourceCurrency += currency
        }
        if (!sourceCurrency || sourceCurrency.split(',').length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_FCASPSCT'))
          return
        }
        accountTitle.sourceCurrency = sourceCurrency
      } else {
        accountTitle.accountingCurrency = false
        accountTitle.adjustExchangeRate = false
        accountTitle.sourceCurrency = this.accountSet.localCurrency
      }
      // 新建科目
      if (!accountTitle.uuid) {
        accountTitle.accountTitleBalance = this.isWT ? this.createBalance(accountTitle) : null
        const loading = getLoading()
        accountTitleApi.save(accountTitle).then(resp => {
          this.innerVisible = false
          this.$emit('success', resp.data)
        }).finally(() => loading.close())
      } else {
        // 修改科目
        this.saveAccountTitleList = []
        if (this.isWT) {
          this.accountTitleBalance = await this.getAccountTitleBalance(accountTitle)
          // 若没有科目余额表,则先创建科目余额表
          if (!this.accountTitleBalance) {
            this.accountTitleBalance = this.createBalance(accountTitle)
          }
          // 有外币核算
          if (accountTitle.accountingCurrency) {
            this.handleAccountTitleBalanceCurrency()
          } else {
            // 无外币核算,只保留RMB Currency
            if (this.accountTitleBalance && this.accountTitleBalance.accountTitleBalanceCurrency) {
              let balanceCurrency
              for (const item of this.accountTitleBalance.accountTitleBalanceCurrency) {
                if (item.sourceCurrency === this.accountSet.localCurrency) {
                  balanceCurrency = item
                  break
                }
              }
              this.accountTitleBalance.accountTitleBalanceCurrency = []
              this.accountTitleBalance.accountTitleBalanceCurrency.push(balanceCurrency)
              this.saveAccountTitleList.push(this.accountTitleBalance)
            }
          }
        }
        // 检查凭证是否用过辅助核算项目"AccountTitleService", "checkAccountEntryAuxiliaryCreate"
        const params = {}
        params.accountTitle = this.form.accountTitle
        params.accountingSetKey = this.accountSet.uuid
        // 获取当前年份
        const currentYear = new Date().getFullYear()
        params.beginDate = this.isWT ? this.fiscalPeriod.beginDate : String(currentYear) + '-01-01'
        params.endDate = this.isWT ? this.fiscalPeriod.endDate : String(currentYear) + '-12-31'
        accountTitleApi.checkAccountEntryAuxiliaryCreate(params).then(resp => {
          this.checkAccountEntryAuxiliaryCreateHandler(resp)
        })
      }
    },
    async checkAccountEntryAuxiliaryCreateHandler(resp) {
      const sourceRow = this.sourceRow
      const accountTitle = this.form
      const data = resp.data
      if (data['customer'] && sourceRow.auxiliaryCustomer && !accountTitle.auxiliaryCustomer) {
        this.$message.warning(this.$t('CargoMsg.Cargo_VHBCFSACCTBC'))
        return
      }
      if (data['supplier'] && sourceRow.auxiliarySupplier && !data['customer'] && !accountTitle.auxiliarySupplier) {
        this.$message.warning(this.$t('CargoMsg.Cargo_VHBCFSAVCTBC'))
        return
      }
      if (data['sales'] && sourceRow.auxiliarySales && !accountTitle.auxiliarySales) {
        this.$message.warning(this.$t('CargoMsg.Cargo_VHBCFSASCTBC'))
        return
      }
      if (data['projectNumber'] && sourceRow.auxiliaryProjectNumber && !accountTitle.auxiliaryProjectNumber) {
        this.$message.warning(this.$t('CargoMsg.Cargo_VHBCFSAICTBC'))
        return
      }
      if (data['department'] && sourceRow.auxiliaryDepartment && !accountTitle.auxiliaryDepartment) {
        this.$message.warning(this.$t('CargoMsg.Cargo_VHBCFSADCTBC'))
        return
      }
      if (this.isWT && this.accountTitleBalance && !this.accountTitleBalance.accountTitleBalanceCurrency) this.accountTitleBalance.accountTitleBalanceCurrency = []
      accountTitle.accountTitleBalance = this.isWT ? this.accountTitleBalance : null
      const loading = getLoading()
      await accountTitleApi.save(accountTitle).then(resp => {
        this.innerVisible = false
        this.$emit('success', resp.data)
      }).finally(() => loading.close())
    },
    closeHandler(params) {
      this.innerVisible = false
      if (params) {
        this.$emit('close', params)
      } else {
        this.$emit('close')
      }
    },
    auxiliaryChangeHandler(value) {
      if (!value) {
        this.form.auxiliaryCustomer = false
        this.form.auxiliarySupplier = false
        this.form.auxiliarySales = false
        this.form.auxiliaryProjectNumber = false
        this.form.auxiliaryDepartment = false
      }
    },
    accountingQuantityChangeHandler(value) {
      if (!value) {
        this.form.unit = ''
      }
    },
    currencyChangeHandler(value) {
      if (!value) {
        this.form.accountingCurrency = false
      }
    },
    handleAccountTitleBalanceCurrency() {
      const balanceCurrencyArray = []
      const currencyArray = this.form.sourceCurrency.split(',')
      let balanceCurrency
      for (const currency of currencyArray) {
        // 从Balance得BalanceCurrency
        balanceCurrency = this.getBalanceCurrencyFromEntity(currency)
        // 无BalanceCurrency新建
        if (!balanceCurrency) {
          balanceCurrency = this.createBalanceCurrency(null, currency)
        }
        balanceCurrencyArray.push(balanceCurrency)
      }
      // 先清空Balance.balanceCurrency
      this.accountTitleBalance.accountTitleBalanceCurrency = []

      for (const item of balanceCurrencyArray) {
        if (item.accountTitleBalanceUuid === this.accountTitleBalance.uuid) {
          this.accountTitleBalance.accountTitleBalanceCurrency.push(item)
        } else {
          item.accountTitleBalanceUuid = this.accountTitleBalance.uuid
        }
      }
    },
    createBalance(accountTitle) {
      const balance = {}
      balance.accountTitle = accountTitle.accountTitle
      balance.accountSetUuid = this.accountSet.uuid
      balance.accountTitleBalanceCurrency = []
      const currencyArray = accountTitle.sourceCurrency.split(',')
      let balanceCurrency
      for (const currency of currencyArray) {
        balanceCurrency = this.createBalanceCurrency(balance, currency)
        balance.accountTitleBalanceCurrency.push(balanceCurrency)
      }
      return balance
    },
    createBalanceCurrency(accountTitleBalance, currency) {
      const balanceCurrency = {}
      balanceCurrency.accountTitle = this.form.accountTile
      balanceCurrency.sourceCurrency = currency
      if (accountTitleBalance) {
        balanceCurrency.year = accountTitleBalance.year
        balanceCurrency.month = accountTitleBalance.month
      }
      return balanceCurrency
    },
    async getAccountTitleBalance() {
      const params = {}
      params.accountSetUuid = this.accountSet.uuid
      params.accountTitle = this.form.accountTitle
      const list = await accountTitleBalanceApi.query(params).then(resp => resp.data.list)
      return list ? list[0] : {}
    },
    getBalanceCurrencyFromEntity(value) {
      if (!this.accountTitleBalance) return null
      for (const item of this.accountTitleBalance.accountTitleBalanceCurrency) {
        if (item.sourceCurrency === value) {
          return item
        }
      }
      return null
    },
    initForm() {
      this.form = {
        accountTitle: null,
        accountTitleName: '',
        subType: this.subTypeDDL[this.accountTitleType - 1][0].code,
        debitCrebit: true,
        auxiliary: false,
        auxiliaryCustomer: false,
        auxiliarySupplier: false,
        auxiliarySales: false,
        auxiliaryProjectNumber: false,
        auxiliaryDepartment: false,
        accountingQuantity: false,
        unit: '',
        accountingCurrency: false,
        adjustExchangeRate: false,
        currentAccount: false,
        sourceCurrency: [this.accountSet.localCurrency],
        defaultDepartment: null
      }
      if (this.superAccountTitle) this.form.accountTitle = this.superAccountTitle.accountTitle
    },
    async getCurrentFiscalPeriod() {
      // this.fiscalPeriod = await fiscalPeriodApi.getCurrentFiscalPeriod({ accountingSetKey: this.accountSet.uuid }).then(resp => resp.data)
    }
  }
}
</script>

<style scoped>

</style>
